import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=8f280f10&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./_id.vue?vue&type=style&index=1&id=8f280f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f280f10",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/builds/master/frontend/frontend-universe/components/avatar.vue').default,Share: require('/builds/master/frontend/frontend-universe/components/share.vue').default,SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default,Preview: require('/builds/master/frontend/frontend-universe/components/preview.vue').default,Card: require('/builds/master/frontend/frontend-universe/components/card/card.vue').default})
